/**
 * Coda offline: quali rifiuti 409 «duplicate key» di un inserimento sono rifiuti veri.
 *
 * Regola storica (invariata per tutte le tabelle): un 409 di unicità su un inserimento vale «già inviato»
 * (reinvio della stessa riga, o vincoli pensati per l'idempotenza come `uq_timbrature_eventi_client_event`).
 * Unica eccezione (F4.1, docs/sicurezza/DDT-NUMERO-PER-FORNITORE.md §6): gli indici del numero DDT. Lì un
 * 409 è un doppione vero, salvo che le righe con quegli id esistano già sul server (reinvio arrivato).
 */
export const INDICI_NUMERO_DDT = [
  "idx_ddt_cantiere_unique_numero",
  "idx_ddt_cantiere_numero_entrata",
  "idx_ddt_cantiere_numero_uscita",
] as const;

/** Il messaggio Postgres nomina uno degli indici del numero DDT? */
export function violaIndiceNumeroDdt(message: string): boolean {
  return INDICI_NUMERO_DDT.some((nome) => message.includes(`"${nome}"`));
}
